/**
 * Module-level configuration for Juridika media URLs.
 * Allows injection of runtime config into schema transforms.
 */

let mediaBaseUrl: string | undefined

export function setJuridikaMediaUrl(url: string) {
  mediaBaseUrl = url
}

/**
 * Returns the media base URL or undefined if not configured.
 * When undefined, images will not be resolved.
 */
export function getJuridikaMediaUrl(): string | undefined {
  return mediaBaseUrl
}
